import { Card, CardHeader, CardSection } from 'lib/components';
import { CancelPlanReasonForm, DefaultLayout } from '../../../components';

const CancelFeedbackPage = () => (
  <DefaultLayout backTo="/account/cancel">
    <Card>
      <CardSection>
        <CardHeader>
          <h3>Why do you want to cancel your subscription?</h3>
        </CardHeader>

        <CancelPlanReasonForm />
      </CardSection>
    </Card>
  </DefaultLayout>
);

export default CancelFeedbackPage;
